import { render } from "./ContactsPeopleContactInfo.vue?vue&type=template&id=56aef8a8"
import script from "./ContactsPeopleContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactsPeopleContactInfo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__